import { render, staticRenderFns } from "./PasswordPolicyEdit.vue?vue&type=template&id=82366ff0"
import script from "./PasswordPolicyEdit.vue?vue&type=script&lang=js"
export * from "./PasswordPolicyEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports